import React, { useState, useRef, useEffect } from "react";

const FooterC = () => {
  return (
    <footer className="footer-container">
      <div className="footer">
        <p className="footer align-items-center">
          &copy; Copyright {new Date().getFullYear()} All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default FooterC;
